import { render, staticRenderFns } from "./wipsum.vue?vue&type=template&id=0ec98ed9&scoped=true&"
import script from "./wipsum.vue?vue&type=script&lang=js&"
export * from "./wipsum.vue?vue&type=script&lang=js&"
import style0 from "./wipsum.vue?vue&type=style&index=0&id=0ec98ed9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec98ed9",
  null
  
)

export default component.exports